import { useState, useCallback } from 'react';

export const useToken = () => {
    const [token, setTokenInternal] = useState(() => {
        // Initialize state from localStorage
        return localStorage.getItem('token') || null;
    });

    const setToken = useCallback((newToken) => {
        if (typeof newToken === 'string') {
            localStorage.setItem('token', newToken);
            setTokenInternal(newToken);
        } else {
            console.warn('Attempted to set token with a non-string value:', newToken);
        }
    }, []);

    return [token, setToken];
};
